import { html, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { WEB_COMPONENT_RESUME_PROTECTION } from '../../../../../webcomponents.constants';
import { FontSizes } from '../../../../../types/common/types';
import { translateFn } from '../../../../../utils/translator.helper';
import { GzCheckboxWebComponent } from '../../../../../ui/gzCheckbox';
import { styles } from './view/styles';

@customElement(WEB_COMPONENT_RESUME_PROTECTION)
export class GzResumeProtectionComponent extends LitElement {
  static get styles() {
    return styles;
  }

  @query('#create-full-scan-task')
  createFullScanTask: GzCheckboxWebComponent;

  render() {
    return html`
        <gz-text fontsize="${FontSizes.HEADING_6}" class="pb-2">${translateFn('Endpoint protection will resume immediately, ensuring all suspended modules are reactivated.')}</gz-text>
        <gz-checkbox gz-form-input id="create-full-scan-task" label="${translateFn('Run a full scan on the endpoint')}"></gz-checkbox>`;
  }
}
